import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import helpers from "helpers/index";
import { IQueryParams } from "queries";

/**
*   Interface/model file auto generate for Geographic_provinces
*   Interface for back-end
*   Model for front-end.
*   They are the same!
*/
export interface TypedGeographic_provinces {
    id?: string;
    code?: string;
    name?: string;
    slug?: string;
    type?: string;
    name_with_type?: string;
}


/**
 *   Interface/model file auto generate for Geographic_wards
 *   Interface for back-end
 *   Model for front-end.
 *   They are the same!
 */
export interface TypedGeographic_wards {
    id?: string;
    code?: string;
    name?: string;
    slug?: string;
    type?: string;
    name_with_type?: string;
    path?: string;
    path_with_type?: string;
    parent_code?: string;
}


/** lấy full địa chỉ thông qua 3 mã address: tỉnh, huyện và xã */
export function useGetFullAddressViaGeo() {
    return useMutation({
        mutationKey: ["geographic/fetch_entity_list"],
        mutationFn: (object: { ward: any, province: any }) => axios.get<{ text: string }>(`/geographic${helpers.buildEndUrl(object)}&format=plaintext`).then(response => response.data),
        retry: 1,
    });
}



type IQueryProvince = TypedGeographic_provinces & IQueryParams;

/*
* List of all app
*/
export function useGetProvinces() {
    return useMutation({
        mutationKey: ["geographic_provinces/fetch_entity_list"],
        mutationFn: (object: IQueryProvince) => axios.get<IQueryProvince[]>(`/geographic_provinces${helpers.buildEndUrl(object)}`).then(response => response.data),
        retry: 1,
    });
}

export function useGetProvince() {
    return useMutation({
        mutationKey: ['geographic_provinces/fetch_entity'],
        mutationFn: (province_id: string) => axios.get<IQueryProvince>(`/geographic_provinces/${province_id}`).then((response) => response.data),
        retry: 1,
    });
}

type IQueryWards = TypedGeographic_wards & IQueryParams;

/*
* List of all app
*/
export function useGetWards() {
    return useMutation({
        mutationKey: ["geographic_wards/fetch_entity_list"],
        mutationFn: (object: IQueryWards) => axios.get<IQueryWards[]>(`/geographic_wards${helpers.buildEndUrl(object)}`).then(response => response.data),
        retry: 1,
    });
}

export function useGetWard() {
    return useMutation({
        mutationKey: ['geographic_wards/fetch_entity'],
        mutationFn: (ward_id: string) => axios.get<IQueryWards>(`/geographic_wards/${ward_id}`).then((response) => response.data),
        retry: 1,
    });
}